import { HttpMethod, httpClient } from './http-client';
import { CreateBulkPartActionsRequest, CreatePartActionResponse, PartActionResponse, PartActionTypes } from '../@types/partAction.type';

export const createPartAction = (partAction: CreatePartActionResponse): Promise<PartActionResponse> => {
  return httpClient<PartActionResponse>('/partAction', HttpMethod.Post, partAction);
};

export const getPartActionByServiceId = (serviceId: number): Promise<PartActionResponse[]> => {
  return httpClient<PartActionResponse[]>(`/partActionsByServiceId/${serviceId}`, HttpMethod.Get);
};

export const updatePartActionById = (actionId: number, partAction: CreatePartActionResponse): Promise<PartActionResponse> => {
  return httpClient<PartActionResponse>(`/partAction/${actionId}`, HttpMethod.Put, partAction);
};

export const deletePartActionById = (id: number): Promise<void> => {
  return httpClient<void>(`/partAction/${id}`, HttpMethod.Delete);
};

export const getAllPartActionTypes = (): Promise<PartActionTypes[]> => {
  return httpClient<PartActionTypes[]>('/partActionTypes', HttpMethod.Get);
};

export const createBulkPartActions = (serviceId: number, partActions: CreateBulkPartActionsRequest[]): Promise<PartActionResponse[]> => {
  return httpClient<PartActionResponse[]>(`/partAction/${serviceId}/bulkSubmit`, HttpMethod.Post, partActions);
};
